<div class="modal-backdrop" role="presentation" (click)="closed.emit()"></div>
<section class="inquiry-modal" role="dialog" aria-modal="true" aria-labelledby="inquiry-title">
  <button class="modal-close" type="button" aria-label="Close inquiry form" (click)="closed.emit()">
    ×
  </button>
  <div class="form-heading">
    <p class="section-kicker"><span></span>Inquire now</p>
    <h2 id="inquiry-title">Send Pavillion a message</h2>
    <p>
      Share your details and the team will respond with availability, viewing options, and payment
      guidance.
    </p>
  </div>

  <form class="inquiry-form" (ngSubmit)="inquirySent.emit()">
    <label>
      Full name
      <input
        name="name"
        type="text"
        required
        [ngModel]="inquiry.name"
        (ngModelChange)="update('name', $event)"
      />
    </label>
    <label>
      Phone number
      <input
        name="phone"
        type="tel"
        required
        [ngModel]="inquiry.phone"
        (ngModelChange)="update('phone', $event)"
      />
    </label>
    <label>
      Email
      <input
        name="email"
        type="email"
        [ngModel]="inquiry.email"
        (ngModelChange)="update('email', $event)"
      />
    </label>
    <label>
      Property of interest
      <select
        name="property"
        [ngModel]="inquiry.property"
        (ngModelChange)="update('property', $event)"
      >
        <option value="">General inquiry</option>
        @for (project of projects; track project.slug) {
          <option [value]="project.name">{{ project.name }}</option>
        }
      </select>
    </label>
    <label class="full-field">
      Message
      <textarea
        name="message"
        rows="5"
        required
        [ngModel]="inquiry.message"
        (ngModelChange)="update('message', $event)"
      ></textarea>
    </label>
    <button class="primary-button dark-button" type="submit" [disabled]="messageSending">
      {{ messageSending ? 'Sending...' : 'Send message' }}
    </button>
    @if (messageSent) {
      <p class="form-note">Thanks. Your inquiry has been sent.</p>
    }
    @if (messageError) {
      <p class="form-error">We could not send your inquiry. Please try again.</p>
    }
  </form>
</section>
